// Soft UI Dashboard PRO React Base Styles
import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";

// Soft UI Dashboard PRO helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { inputColors } = colors;
const { borderWidth, borderRadius } = borders;

const input = {
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      const isDarkMode = theme.palette.mode === "dark";
      const isDisabled = Boolean(ownerState?.disabled);
      const disabledBackground = isDarkMode ? "var(--input-bg-color)" : colors.grey[200];
      const disabledBorderColor = isDarkMode ? "var(--input-border-color)" : inputColors.borderColor.main;

      return {
        display: "flex !important",
        padding: `${pxToRem(8)} ${pxToRem(28)} ${pxToRem(8)} ${pxToRem(12)} !important`,
        border: `${borderWidth[1]} solid ${isDisabled ? disabledBorderColor : inputColors.borderColor.main}`,
        borderRadius: `${borderRadius.sm} !important`,
        backgroundColor: isDisabled ? `${disabledBackground} !important` : undefined,

        "& fieldset": {
          border: "none",
        },
      };
    },

    input: ({ theme, ownerState }) => {
      const isDarkMode = theme.palette.mode === "dark";
      const isDisabled = Boolean(ownerState?.disabled);
      const disabledTextColor = isDarkMode ? colors.grey[500] : colors.grey[600];

      return {
        height: pxToRem(22),
        width: "max-content !important",
        color: isDisabled ? `${disabledTextColor} !important` : undefined,
        WebkitTextFillColor: isDisabled ? `${disabledTextColor} !important` : undefined,
      };
    },

    inputSizeSmall: {
      height: pxToRem(14),
    },
  },
};

export default input;
